var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vendor-vacation-list"},[_c('list',{attrs:{"apiList":_vm.apiList,"fs":_vm.vacationFields,"addLink":"/admin/vacations/new","api":"vacations","editLink":"/admin/vacations","title":"Vacations"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }